export const geosMap = [
  {value: 'cities', label: 'Cidade', type: 'Geo::City', parentKey: 'state'},
  {value: 'countries', label: 'País', type: 'Geo::Country', parentKey: null},
  {value: 'regions', label: 'Região', type: 'Geo::Region', parentKey: 'country'},
  {value: 'states', label: 'Estado', type: 'Geo::State', parentKey: 'region'}
]
